__turbopack_context__.v({
  "label": "D8g8WG_label",
  "radio": "D8g8WG_radio",
});
